import { useReplicant } from "@livcg/nodecg-react";
import { MATCH_SYNC_REPLICANT, type MatchSyncReplicant, type ProjectState } from "@livcg/schema";
import { AlertTriangle } from "lucide-react";
import { useEffect, useState } from "react";
import { Drawer } from "./control-room/Drawer.js";
import { PlayerCompareDrawer } from "./control-room/player-compare/PlayerCompareDrawer.js";
import { bannerFor } from "./matchSyncBanner.js";

export function MatchSyncBanner({ slug, state }: { slug: string; state: ProjectState }) {
  const [all] = useReplicant<MatchSyncReplicant>(MATCH_SYNC_REPLICANT);
  const [now, setNow] = useState(Date.now);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(t);
  }, []);
  const b = bannerFor(all?.[slug], now);
  return (
    <>
      {b && (
        <div className="flex items-center gap-2 border-b border-warning/40 bg-warning/15 px-4 py-1.5 text-[12.5px] font-medium text-ink">
          <AlertTriangle className="h-3.5 w-3.5 text-warning" />
          {b.action === "mapping" ? (
            <button type="button" className="underline-offset-2 hover:underline" onClick={() => setOpen(true)}>
              {b.text}
            </button>
          ) : (
            <span>{b.text}</span>
          )}
        </div>
      )}
      <Drawer open={open} onClose={() => setOpen(false)} title="O'yinchilar · dostats bog'lash" width="max-w-4xl">
        <PlayerCompareDrawer slug={slug} state={state} />
      </Drawer>
    </>
  );
}
